﻿import { IComponent, Component, Inject, Input, Output } from "@fiqas/angular-utils";
import { FIQAssist } from "../../app";
import { RecentServiceCasesResult, CompactServiceCase } from "../../models/serviceCase";
import { UserService } from "../../services/fiqassistApi/userService";
import { Application } from "../application"
import { IDisposable } from "../../interfaces/general"
import { IsProcessingService } from "../../services/isProcessingService";
import { LogService } from "../../services/logService";

@Component({
    module: FIQAssist,
    selector: "recentCases",
    templateUrl: "views/recentCases.html",
    require: {
        "application": "^application"
    }
})
class RecentCases implements IComponent {
    public application: Application;
    private disposables: IDisposable[] = [];
    constructor( @Inject() private userService: UserService,
        @Inject() private isProcessingService: IsProcessingService,
        @Inject() private logService: LogService
    ) {

    }

    public $onInit() {
        this.disposables.push(this.application.addOnAccountsChanged(s => this.selectedAccountsChanged(s)));
        let custIds = this.application.selectedCustomers.map(x => x.key);
        this.getData(custIds);
    }


    private async getData(custIds: number[]) {
        if (custIds.length > 0) {
            try {
                this.isProcessingService.StartProcessing();
                let r = await this.userService.RecentServiceCases(custIds, 10);
                this.serviceCases = r.items;
            } catch (e) {
                this.logService.error('RecentCases', 'Error retrieving recentcases', e);
            }
            finally { this.isProcessingService.StopProcessing(); }
        } else {
            this.serviceCases = [];
        }
    }

    public $onDestroy() {
        this.disposables.forEach(d => {
            try { d() } catch (e) { this.logService.warning('RecentCases', 'Error disposing', e); }
        });
    }

    private selectedAccountsChanged(selected: { key: string, text: string }[]) {
        this.getData(selected.map(x => Number(x.key)));
    }

    private serviceCases: CompactServiceCase[];
}